<template>
  <div class="pickup-tickets-container">
    <div
      class="pickup-tickets-wrapper"
      v-if="customerLoyaltyPointsLogs.length === 0"
    >
      <header>
        Customer Loyalty Points
      </header>
      <button class="btn-modal-close" v-on:click="callClose()">&times;</button>
      <div class="pickup-tickets-center-content" v-if="enterTicketDetails">
        <div class="col-lg-6 col-xl-4 mx-auto text-center mb-5">
          <div class="input-material mb-4">
            <input v-model="mobile_number" id="customerLoyalityCheck" type="text" />
            <label>Customer Mobile Number</label>
            <VkeyboardFloat
            :ID="'customerLoyalityCheck'"
            :onClickFun="() => {
              showVKeyboard = !showVKeyboard
            }"
          />
          <Vkeyboard
            :inputName="'customerLoyalityCheck'"
            :showOrHide="showVKeyboard"
            :initialValue="mobile_number"
            @onChangeEvent="() => {}"
            @onKeyEnter="VerifyCustomer"
            @changeKeyboardInput="mobile_number = $event"
            @onClickClose="() => {
              showVKeyboard = false;
            }"
          />
          </div>
          <button class="btn-blue-lg" v-on:click="VerifyCustomer()">
            {{ $t("submit") }}
          </button>
        </div>
      </div>
    </div>
    <div
      class="pickup-tickets-wrapper"
      v-if="customerLoyaltyPointsLogs.length > 0"
    >
      <header>
        Customer Loyalty Points
      </header>
      <button class="btn-modal-close" v-on:click="callClose()">&times;</button>
      <table class="swc-report-table">
        <thead class>
          <tr>
            <th>{{ $t("booking") }} {{ $t("code") }}</th>
            <th>{{ $t("show") }} {{ $t("date") }} {{ $t("time") }}</th>
            <th>{{ $t("transaction") }} {{ $t("date") }} {{ $t("time") }}</th>
            <th>{{ $t("totalamount") }}</th>
            <th>{{ $t("earnpoints") }}</th>
            <th>{{ $t("burnpoints") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(transactionlist,
            transactionlistIndex) in customerLoyaltyPointsLogs"
            :key="transactionlistIndex"
          >
            <td>{{ transactionlist.sb_booking_code }}</td>
            <td>
              {{ transactionlist.t_show_date | dateparse }} -
              {{ transactionlist.t_show_time }}
            </td>
            <td>
              {{ transactionlist.t_booking_date_time | fulldaydateparse }}
            </td>
            <td>{{ transactionlist.sb_total_amount }}</td>
            <td>{{ transactionlist.earnings_points }}</td>
            <td>{{ transactionlist.burnings_points }}</td>
          </tr>
          <tr>
            <td colspan="4"></td>
            <td>
              <strong
                >Total Earn Points :
                {{
                  customerLoyaltyPointsLogs &&
                  customerLoyaltyPointsLogs.length > 0
                    ? customerLoyaltyPointsLogs.reduce(
                        (ac, x) => (ac += x.earnings_points),
                        0
                      )
                    : "-"
                }}</strong
              >
            </td>
            <td>
              <strong
                >Total Burn Points :
                {{
                  customerLoyaltyPointsLogs &&
                  customerLoyaltyPointsLogs.length > 0
                    ? customerLoyaltyPointsLogs.reduce(
                        (ac, x) => (ac += x.burnings_points),
                        0
                      )
                    : "-"
                }}</strong
              >
            </td>
          </tr>
          <tr>
            <td colspan="4"></td>
            <td colspan="2">
              <strong>Total Points : {{ total_points }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Printd from "printd";
import MasterService from "@/services/MasterService";
import PosService from "@/services/PosService";
import OCTemplate from "@/components/Pages/PosBookingContainer/PrintTicketTemplates/One_Copy_Template";
import ThreeCTemplate from "@/components/Pages/PosBookingContainer/PrintTicketTemplates/3_Copies_Template";
import DefaultTemplate from "@/components/Pages/PosBookingContainer/PrintTicketTemplates/Default_Template";
import SReceipt from "@/components/Pages/PosBookingContainer/sales_receipts";
import { EventBus } from "@/main";
// import printJS from "./customPrint/index";
import { mapState, mapGetters, mapActions } from "vuex";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
export default {
  components: {
    "onecopy-template": OCTemplate,
    "threecopy-template": ThreeCTemplate,
    "default-template": DefaultTemplate,
    "sales-receipt": SReceipt,
    Vkeyboard,
    VkeyboardFloat
  },
  props: {
    onClickHandler: { type: Function }
  },
  data() {
    return {
      showVKeyboard: false,
      TemplateList: [],
      booking_code: "",
      mobile_number: "",
      currentPage: 1,
      item: {
        seatPrice: 0,
        seatType: "",
        seatName: ""
      },
      printIndex: 0,
      isReprint: false,
      phone_value: [
        { name: "1" },
        { name: "2" },
        { name: "3" },
        { name: "4" },
        { name: "5" },
        { name: "6" },
        { name: "7" },
        { name: "8" },
        { name: "9" },
        { name: "+" },
        { name: "0" },
        { name: "#" }
      ],
      input_number: "",
      email_address: "",
      first_name: "",
      last_name: "",
      cust_id: null,
      isSearch: false,
      isSetData: false,
      TemplateList: [],
      total_points: null,
      customerLoyaltyPointsLogs: []
    };
  },
  watch: {
    "$store.getters.getIsOldCustomer": function(newVal, oldVal) {
      if (newVal) {
        this.email_address = this.$store.getters.getCustomerDetails.cust_email;
        this.first_name = this.$store.getters.getCustomerDetails.first_name;
        this.last_name = this.$store.getters.getCustomerDetails.last_name;
        this.cust_id = this.$store.getters.getCustomerDetails.cust_id;
      }
    }
  },
  computed: {
    getIsOldCustomer() {
      return this.$store.getters.getIsOldCustomer;
    },
    ticketDetails() {
      return this.$store.getters.TICKET_DETAILS;
    },
    enterTicketDetails() {
      return this.$store.getters.enterTicketDetails;
    },
    showTicketInfo() {
      return this.$store.getters.showTicketInfo;
    }
  },
  beforeMount() {
    const { cinema_id } = this.secureStore.get("USINFO");
  },
  methods: {
    getCinemaTicketTemplate: function(cinema_id) {
      let body = {
        cine_id: cinema_id
      };
      MasterService.TicketTemplateByCinemaID(body).then(response => {
        const { data } = response;
        console.log("data ::::::::::", data);

        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            this.TemplateList = data.Records;
          }
        }
      });
    },
    onClicknumber: function(index) {
      this.input_number += this.phone_value[index].name;
    },
    onClickDelete: function() {
      this.input_number = "";
    },
    onSendSMS() {
      if (this.input_number.length > 0) {
        this.$store.dispatch("updateCustomerBookings", {
          first_name: this.first_name,
          last_name: this.last_name,
          mobile_number: this.input_number,
          cust_email: this.email_address,
          cust_id: this.cust_id
        });
        this.first_name = "";
        this.last_name = "";
        this.input_number = "";
        this.email_address = "";
        this.isSearch = false;
      }
    },
    onSearch: function() {
      if (this.input_number.length > 0) {
        // this.$toasted.show("Ticket Booking Details Sent Successfuly. ");
        this.$store.dispatch("setUserDeatils", {
          sb_mobile_number: this.input_number
        });
        this.isSearch = true;
        this.$store.dispatch("onSetAndSendLog", {
          action: `SMS option selected for ticket at number : ${this.input_number}`,
          page_name: "POS booking",
          api_name: window.location.hash
        });
      } else {
        this.$toasted.show("Please enter Mobile Number.");
      }
      // SendSmS Service
    },
    goToRoute: function() {
      this.$store.dispatch("onSetAndSendLog", {
        action: this.isReprint
          ? `Selected Reprint option .`
          : `Selected Print option .`,
        page_name: "POS booking",
        api_name: window.location.hash
      });
      this.isReprint = true;
      const { cinema_id } = this.secureStore.get("USINFO");

      //For electron
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf(" electron/") > -1) {
        // Electron-specific code
        try {
          if (this.$socket) {
            this.$socket.emit("on_print_ticket", {
              showBookingId: this.showBookingId,
              cinema_id
            });
          }
        } catch (err) {}
      } else {
        const p = new Printd();
        console.log(
          "this.TemplateList[0].template_id :",
          this.TemplateList[0].template_id
        );

        if (this.TemplateList[0].template_id == 1) {
          EventBus.$emit("printThreeCopyTemp");
        } else if (this.TemplateList[0].template_id == 2) {
          EventBus.$emit("printOneCopyTemp");
        } else if (this.TemplateList[0].template_id == 3) {
          EventBus.$emit("printDefaultTemp");
        } else {
          EventBus.$emit("printDefaultTemp");
        }
      }
    },
    PrintReceipt: function() {
      this.$store.dispatch("onSetAndSendLog", {
        action: `Selected PrintReciept button for ticket print.`,
        page_name: "POS Final Ticket",
        api_name: window.location.hash
      });
      // const p = new Printd();
      // p.print(this.$refs.SalesReceipt, []);
      EventBus.$emit("printSalesReceipt");
    },
    callClose: function() {
      // this.$store.dispatch("resetPickUpTicketDetails");
      this.onClickHandler("PosCustomerLoyaltyPoints");
    },
    async VerifyCustomer() {
      if (this.mobile_number !== "") {
        const { data } = await PosService.UpdateCustomerBookingDetails({
          sb_mobile_number: this.mobile_number
        });
        console.log("data :>> ", data);
        if (data && data.status && data.Records.length > 0) {
          const { cust_id } = data.Records[0];
          const payload = {
            clp_id: cust_id,
            limit: 5,
            currentPage: this.currentPage
          };
          const {
            data: customerPointsData
          } = await PosService.GetCustomerLoyaltyPointsBYID(payload);

          if (
            customerPointsData &&
            customerPointsData.status &&
            customerPointsData.Records.length > 0
          ) {
            this.customerLoyaltyPointsLogs = customerPointsData.Records;
            this.total_points = customerPointsData.Records[0].points;
          } else {
            this.$toasted.show('No Records Found')
          }
        } else {
          this.$toasted.show('No Records Found')
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/posCustomerLoyaltyPoints.vue